import { render } from "./MenuHeaderPopup.vue?vue&type=template&id=68561784"
import script from "./MenuHeaderPopup.vue?vue&type=script&lang=js"
export * from "./MenuHeaderPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__